/** The bar above the chat box listens for this: show this decision, opened. */
export const DECIDE_EVENT = 'ai-decide'

export function focusDecision(id: number) {
  window.dispatchEvent(new CustomEvent(DECIDE_EVENT, { detail: id }))
}
